import moment from 'moment';
import curry from "ramda/es/curry";
import filter from "ramda/es/filter";
import isNilOrEmpty from "ramda-extension/es/isNilOrEmpty";
export const asIsoDateModelParser = curry((dateFormat, value)=>{
    if (value instanceof Object || moment(value, dateFormat, true).isValid()) {
        return isNilOrEmpty(value) ? value : moment(value, dateFormat).format();
    }
    return value;
});
export const multipleFormatsAsIsoDateModelParser = curry((dateFormats, dateFormat, value)=>{
    const changeOfValue = (format)=>asIsoDateModelParser(format)(value) !== value;
    if (changeOfValue(dateFormat)) {
        return asIsoDateModelParser(dateFormat)(value);
    }
    const compare = filter(changeOfValue, dateFormats);
    return compare[0] ? asIsoDateModelParser(compare[0])(value) : value;
});
/**
 * @param {array || string} dateFormatFrom
 * @param {string} dateFormatTo
 * @param {string} value
 */ export const asDateModelParser = curry((dateFormatFrom, dateFormatTo, value)=>{
    const date = moment(value, dateFormatFrom, true);
    if (date.isValid()) {
        return date.format(dateFormatTo);
    }
    return value;
});
